import { TableCell } from "./table-cell";
import { styles } from "./table-cell.styles";
import { template } from "./table-cell.template";
import { DesignSystem } from "../design-system";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-table-cell>
 */
export const definition = TableCell.compose({
    name: `${DesignSystem.prefix}-table-cell`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=table-cell.definition.js.map